import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import React from 'react';

export const DesktopTable = ({
                                 sortTableBy,
                                 translationsGroup,
                                 columnsNames,
                                 items,
                                 buttons,
                             }) => {

    const { t } = useTranslation();

    return (
        <Table striped bordered hover>
            <thead>
            <tr style={{ textAlign: 'center' }}>
                <th />
                {columnsNames.map((name, index) => {
                    return (
                        <th key={index}>
                            <Button variant='light'
                                    onClick={() => sortTableBy(name)}>
                                {t(translationsGroup + name)}
                            </Button>
                        </th>
                    );
                })}
                {buttons != null && buttons.length > 0 ? <th /> : <></>}
            </tr>
            </thead>
            <tbody>
            {items.map((item, index) => {
                return (
                    <tr key={index} style={{ textAlign: 'center' }}>
                        <td>{index + 1}</td>
                        {columnsNames.map((column) => {
                            return (
                                <td key={index + column}>
                                    {item[column]}
                                </td>
                            );
                        })}
                        {buttons != null && buttons.length > 0
                            ? <td>
                                <div>
                                    {buttons.map((button, index) => {
                                        const originalOnClick = button.element.props.onClick;
                                        const originalDisabled = button.element.props.disabled;
                                        return React.cloneElement(button.element, {
                                            onClick: button.element.props.obj != null
                                                ? (...args) => originalOnClick(...args)
                                                : () => originalOnClick(item),
                                            disabled: originalDisabled != null ? button.element.props.disabled(item) : false,
                                            obj: item,
                                            key: 'button-' + index,
                                        });
                                    })}
                                </div>
                            </td>
                            : <></>}
                    </tr>
                );
            })}
            </tbody>
        </Table>
    );
};